import React, {useState, useEffect, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {densityUnitItem} from '../../../App';
import MenuContext from '../../../context/menuContext';
import ConfigContext from '../../../context/configContext';
import VolumeUnit from './volume-unit';
import TemperatureUnit from './temperature-unit';

function DensityUnit({onExit}) {
  const {onComponent, setDisableMenu} = useContext(MenuContext);
  const {config, onUpdate} = useContext(ConfigContext);
  const leftPress = useKeyPress('ArrowLeft');

  useEffect(() => {
    if (!leftPress) return;

    onComponent(<VolumeUnit />);
  }, [leftPress]);

  const onRight = selected => {
    onUpdate('density', {...config.density, unit: selected.name});
    // setDisableMenu(false);
    onComponent(<TemperatureUnit />);
  };

  return (
    <FullBodyMenuView
      title="Select Density Unit"
      menuItems={densityUnitItem}
      initialSelected={config.density.unit}
      onRightCallback={onRight}
    />
  );
}
export default DensityUnit;
